<div class="auth-page">
  <div class="auth-bg-pattern"></div>

  @if (isLoading) {
    <div class="auth-card auth-card--loading">
      <i class="pi pi-spin pi-spinner auth-spinner"></i>
      <p class="auth-loading-text">Loading your profile...</p>
    </div>
  } @else {
    <div class="auth-card">
      <div class="auth-icon-wrap">
        <div class="auth-icon auth-icon-danger">
          <i class="pi pi-lock"></i>
        </div>
      </div>

      <h1 class="auth-title">Access Denied</h1>
      <p class="auth-subtitle">You don't have permission to access this page.</p>

      <div class="auth-user-info" *ngIf="user">
        <i class="pi pi-user auth-icon-sm"></i>
        Signed in as <strong>{{ user.displayName }}</strong>
      </div>

      <div class="auth-actions">
        <p-button
          label="Sign Out"
          icon="pi pi-sign-out"
          (onClick)="logout()"
          severity="secondary"
          styleClass="auth-btn auth-btn-secondary" />
      </div>

      <p class="auth-footer">
        <i class="pi pi-info-circle auth-icon-sm"></i>
        Contact your administrator for access
      </p>
    </div>
  }
</div>
